module.exports = __webpack_public_path__ + "src/assets/textures/env/tractor_/tractor_opacity_bake_1k.png";